import assertNever from "../helpers/assertNever";
import { ReservedTicketType, TicketTypeCartItem } from "../types";

type SetQuantityAction = {
  type: "set_ticket_quantity";
  ticketType: TicketTypeCartItem;
  quantity: number;
};

type SetCartFromReservation = {
  type: "set_cart_from_reservation";
  tickets: ReservedTicketType[];
};

export type CartReducerAction = SetQuantityAction | SetCartFromReservation;

export type CartReducerState = {
  [ticketTypeId: string]: number;
};

function cartReducer(state: CartReducerState, action: CartReducerAction): CartReducerState {
  switch (action.type) {
    case "set_ticket_quantity": {
      const newState = { ...state };
      newState[action.ticketType.ticketTypeId] = action.quantity;
      return newState;
    }

    case "set_cart_from_reservation": {
      const tickets = action.tickets.reduce((acc, ticket) => {
        if (acc[ticket.ticketTypeId]) {
          acc[ticket.ticketTypeId] += 1;
        } else {
          acc[ticket.ticketTypeId] = 1;
        }
        return acc;
      }, {} as CartReducerState);
      return tickets;
    }

    default:
      return assertNever(action);
  }
}

export default cartReducer;
